var configs = {
    clear: false,
    form: false,
    input: false,
    submit: false
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/searchfield/_configs.js
// module id = 478
// module chunks = 0